import { useEffect, useState } from "react";
import * as uuid from "uuid";
import slugify from "slugify";

import styles from "../../../../styles/catalog-tags.module.scss";

import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox";
import { Icon } from "../../../components/core/Icon";
import { Input } from "../../../components/Input";

import { AssetsAPI } from "../../../../providers/AssetsAPI";

export default function TagForm({ currentTags, onChangeTags, editTag = null }) {
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState({});
    const [payload, setPayload] = useState({
        name: "",
        active: false,
        iconUrl: "",
    });

    useEffect(() => {
        if (editTag) setPayload(editTag);
    }, []);

    const handleSetImage = async (e) => {
        const file = e.target.files[0];

        if (file) {
            const maxFileSize = 5;
            const fileSize = file.size / 1024 / 1024;
            const fileType = file.type;

            if (fileSize > maxFileSize) {
                alert({
                    text: `Escolha um arquivo com no máximo ${maxFileSize}MB`,
                });
                return false;
            }

            const pattern = /image-*/;

            if (!fileType.match(pattern)) {
                alert({ text: "Arquivo inválido." });

                return false;
            }

            setLoading(true);
            let reader = new FileReader();
            reader.onload = async (readerEvent) => {
                setImage({ ...image, imageURI: readerEvent.target.result });
                const response = await AssetsAPI.PostAssets({
                    mime_type: fileType,
                    file: readerEvent.target.result.split("base64,")[1],
                });
                delete payload.iconUrl;
                setPayload(
                    Object.assign({ iconUrl: response.getData({}) }, payload)
                );
                setLoading(false);
            };

            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = () => {
        setLoading(true);

        // setTimeout(async () => {
        const tagType = slugify(payload.name, {
            lower: true,
            trim: true,
        });
        const tagId = payload.id || uuid.v4();
        let newTags = [];

        if (!editTag) {
            newTags = [
                ...currentTags,
                {
                    ...payload,
                    type: tagType,
                    id: tagId,
                },
            ];
        } else {
            newTags = currentTags.map((tag) => {
                if (tag.id === editTag.id)
                    return {
                        ...payload,
                        type: tagType,
                    };
                return tag;
            });
        }

        onChangeTags(newTags);
        // }, [0]);
    };

    return (
        <div className={styles.tagsContainer}>
            <div className="d-flex align-center">
                <label htmlFor="tag-picture" className={styles.customFileInput}>
                    <span className={styles.plus}>
                        <Icon name="plus" color="#fff" />
                    </span>
                    <input
                        type="file"
                        id="tag-picture"
                        accept="image/*"
                        onChange={(e) => handleSetImage(e)}
                    />
                    {image.imageURI ? (
                        <img src={image.imageURI} alt={payload.name || ""} />
                    ) : payload.iconUrl ? (
                        <img
                            src={
                                process.env.REACT_APP_ASSETS_URL +
                                `/` +
                                payload.iconUrl
                            }
                            alt={payload.name || ""}
                        />
                    ) : (
                        <Icon name="image-polaroid" size="2x" light />
                    )}
                </label>
            </div>

            <Input
                design="two"
                className="w-100 mb-20"
                floatLabel="Nome da tag"
                value={payload.name}
                onChange={(e) =>
                    setPayload({ ...payload, name: e.target.value })
                }
            />
            <Checkbox
                name="showTag"
                checked={payload.active}
                onChange={(active) => setPayload({ ...payload, active })}
            >
                Exibir tag no cardápio
            </Checkbox>

            <div className={styles.footer}>
                <Button
                    type="button"
                    design="primary"
                    className="w-100"
                    disabled={!payload?.name}
                    loading={loading}
                    onClick={() => {
                        handleSubmit();
                    }}
                >
                    {!editTag ? "Criar Tag" : "Editar Tag"}
                </Button>
            </div>
        </div>
    );
}
